var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ma-auto",attrs:{"small":"","fab":"","icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('editBrand')}}},[_c('v-icon',[_vm._v("mdi-pencil")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }